<template>
  <div>
    <vue-element-loading
      :active="loading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showSnackbar" :color="snackbarColor" right bottom>
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12>
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading" style="color: #005f32">LATE ARRIVAL PENALTY</span> -->
          <v-flex xs12 align-self-center py-2>
            <v-layout wrap justify-start>
              <v-flex xl2 lg3 md4 pb-2 sm12 xs12 px-2 text-left>
                <span class="kumbhRegular" style="font-size: 14px">
                  Pick a financial year
                </span>
                <v-menu
                  v-model="yearMenu"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  min-width="300px"
                  max-width="400px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="selectedFyear ? displayYear : 'All Financial Years'"
                      outlined
                      readonly
                      dense
                      class="rounded-xl mt-1"
                      append-icon="mdi-chevron-down"
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      color="#005f32"
                    ></v-text-field>
                  </template>
                  <v-card class="pa-4">
                    <v-layout wrap>
                      <v-flex
                        v-for="year in financialYears"
                        :key="year.value"
                        xs6
                        sm6
                        md6
                        pa-1
                      >
                        <div
                          :class="[
                            'year-pill',
                            selectedFyear === year.value ? 'active' : ''
                          ]"
                          @click="selectYear(year.value)"
                        >
                          {{ year.text }}
                        </div>
                      </v-flex>
                      <v-flex xs12 pa-1 mt-2>
                        <v-btn
                          small
                          block
                          text
                          color="#005f32"
                          class="kumbhBold"
                          @click="selectYear(null)"
                        >
                          Clear Selection
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>
              
              <v-flex xl2 lg3 md4 pb-2 sm12 xs12 px-2 text-left>
                <span class="kumbhRegular" style="font-size: 14px">
                  Show monthly data
                </span>
                <v-menu
                  v-model="monthMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="selectedMonth ? formatMonthDisplay(selectedMonth) : 'All Months'"
                      outlined
                      readonly
                      dense
                      class="rounded-xl mt-1"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      clearable
                      @click:clear="selectedMonth = null"
                      color="#005f32"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedMonth"
                    type="month"
                    no-title
                    scrollable
                    @input="monthMenu = false"
                    color="#005f32"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>

        <v-layout wrap justify-start pa-0 pa-xs-0 pa-sm-2 pa-md-5 pa-lg-5 pa-xl-5>
          <v-flex xs12>
            <v-card class="elevation-2 rounded-lg overflow-hidden">
              <v-data-table
                :headers="headers"
                :items="penaltyRows"
                :loading="loading"
                class="elevation-0 custom-penalty-table"
                :items-per-page="10"
                :page.sync="page"
                hide-default-footer
              >
                <template v-slot:body.prepend>
                  <tr>
                    <td :colspan="headers.length" class="pa-0">
                      <v-layout wrap justify-start py-5>
                        <v-flex xs12 sm8 md10 lg10 pl-6 text-left>
                          <span class="kumbhRegular">
                            Late arrival penalty {{ selectedMonth ? 'for ' + formatMonthDisplay(selectedMonth) : (selectedFyear ? 'for ' + displayYear : '') }} retrieved Successfully
                          </span>
                        </v-flex>
                        <v-flex xs12 sm4 md2 lg2 px-6 text-right>
                          <v-btn
                            style="font-family: kumbhBold; text-transform: capitalize; font-size: 14px;"
                            dark
                            block
                            class="rounded-xl"
                            color="#005f32"
                            :loading="excelLoading"
                            @click="downloadPenaltyExcel"
                          >
                            Excel Download
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <div class="pa-16 kumbhRegular text-center">No Data found!</div>
                </template>
              </v-data-table>
            </v-card>

            <v-layout wrap justify-center py-8 v-if="totalCount > dataLimit">
              <v-flex xs12 text-center>
                <v-pagination
                  v-model="page"
                  :length="Math.ceil(totalCount / dataLimit)"
                  :total-visible="7"
                  circle
                  color="#005f32"
                  class="custom-pagination"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "lateArrivalPenalty",
  data() {
    return {
      loading: false,
      page: 1,
      totalCount: 0,
      dataLimit: 10,
      excelLoading: false,
      showSnackbar: false,
      snackbarMsg: "",
      snackbarColor: "black",
      yearMenu: false,
      monthMenu: false,
      selectedFyear: null,
      selectedMonth: null,
      financialYears: [
        { text: "2026-27", value: "2026-2027" },
        { text: "2025-26", value: "2025-2026" },
        { text: "2024-25", value: "2024-2025" },
        { text: "2023-24", value: "2023-2024" },
        { text: "2022-23", value: "2022-2023" },
        { text: "2021-22", value: "2021-2022" },
      ],
      penaltyRows: [],
      headers: [
        { text: "Employee ID", value: "employeeId", class: "white--text font-weight-bold" },
        { text: "Employee", value: "employeeName", class: "white--text font-weight-bold" },
        { text: "Late Count", value: "lateCount", class: "white--text font-weight-bold" },
        { text: "Penalty Count", value: "penaltyCount", class: "white--text font-weight-bold" },
        { text: "Financial Year", value: "fyear", class: "white--text font-weight-bold" },
      ],
    };
  },
  computed: {
    displayYear() {
      const yr = this.financialYears.find((y) => y.value === this.selectedFyear);
      return yr ? yr.text : "";
    },
  },
  created() {
    this.setDefaultPeriod();
  },
  watch: {
    selectedMonth() {
      if (this.page === 1) {
        this.getLateArrivalPenalty();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.getLateArrivalPenalty();
    }
  },
  mounted() {
    this.getLateArrivalPenalty();
  },
  methods: {
    formatMonthDisplay(dateStr) {
      if (!dateStr) return "";
      const [year, month] = dateStr.split("-");
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    },
    formatMonthParam(dateStr) {
      if (!dateStr) return "";
      const [year, month] = dateStr.split("-");
      return `${month}-${year}`;
    },
    setDefaultPeriod() {
      const now = new Date();
      const currentMonth = now.getMonth() + 1; // 1-indexed
      const currentYear = now.getFullYear();

      // Set month (YYYY-MM)
      this.selectedMonth = `${currentYear}-${String(currentMonth).padStart(2, '0')}`;

      // Set financial year (April starting)
      let fyearStart, fyearEnd;
      if (currentMonth >= 4) {
        fyearStart = currentYear;
        fyearEnd = currentYear + 1;
      } else {
        fyearStart = currentYear - 1;
        fyearEnd = currentYear;
      }
      this.selectedFyear = `${fyearStart}-${fyearEnd}`;
    },
    selectYear(val) {
      if (this.selectedFyear === val) {
        this.selectedFyear = null;
      } else {
        this.selectedFyear = val;
      }
      if (this.page === 1) {
        this.getLateArrivalPenalty();
      } else {
        this.page = 1;
      }
    },
    async getLateArrivalPenalty() {
      this.loading = true;
      try {
        let url = "/late-arrival-penalty";
        const params = [];
        params.push(`pageNo=${this.page}`);
        params.push(`dataLimit=${this.dataLimit}`);
        if (this.selectedFyear) params.push(`fyear=${this.selectedFyear}`);
        if (this.selectedMonth) params.push(`month=${this.formatMonthParam(this.selectedMonth)}`);
        if (params.length > 0) url += `?${params.join("&")}`;

        const response = await axios({
          method: "GET",
          url: url,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        });

        const rawData = response && response.data ? response.data : { data: [], totalCount: 0 };
        const rows = Array.isArray(rawData.data) ? rawData.data : [];
        this.totalCount = rawData.totalCount || 0;

        this.penaltyRows = rows.map((item) => ({
          employeeId: item.employeeId || "-",
          employeeName: item.employeeName || "-",
          lateCount: item.lateCount || 0,
          penaltyCount: item.penaltyCount || 0,
          fyear: item.fyear || "-",
        }));
      } catch (error) {
        this.toast(
          (error && error.response && error.response.data && error.response.data.message) ||
            "Unable to fetch late arrival penalty data.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
    downloadPenaltyExcel() {
      this.excelLoading = true;
      let url = "/late-arrival-penalty/excel";
      const params = [];
      if (this.selectedFyear) params.push(`fyear=${this.selectedFyear}`);
      if (this.selectedMonth) params.push(`month=${this.formatMonthParam(this.selectedMonth)}`);
      
      if (params.length > 0) {
        url += `?${params.join("&")}`;
      }
      axios({
        method: "GET",
        url: url,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        responseType: "blob",
      })
        .then((response) => {
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

          const disposition = response.headers["content-disposition"] || "";
          const filenameMatch = disposition.match(/filename\*?=(?:UTF-8''|")?([^;"]+)/i);
          const fileName = filenameMatch
            ? decodeURIComponent(filenameMatch[1].replace(/"/g, "").trim())
            : "Late-Arrival-Penalty.xlsx";

          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = fileName;
          anchor.click();
          window.URL.revokeObjectURL(url);
          this.toast("Excel downloaded successfully", "success");
        })
        .catch((error) => {
          this.toast(
            (error && error.response && error.response.data && error.response.data.message) ||
              "Unable to download late arrival penalty excel.",
            "error"
          );
        })
        .finally(() => {
          this.excelLoading = false;
        });
    },
    toast(msg, type = "success") {
      this.snackbarMsg = msg;
      this.snackbarColor = type === "success" ? "#005f32" : "error";
      this.showSnackbar = true;
    },
  },
};
</script>

<style scoped>
.itemHeading {
  font-family: 'KumbhBold';
  font-size: 20px;
}
.kumbhRegular {
  font-family: 'KumbhRegular';
}
.custom-penalty-table >>> thead {
  background-color: #005f32 !important;
}
.custom-penalty-table >>> th {
  font-family: "kumbhMedium" !important;
  font-size: 15px !important;
  color: #ffffff !important;
}
.custom-penalty-table >>> td {
  font-family: "kumbhMedium" !important;
  font-size: 14px !important;
}

.year-pill {
  border: 1px solid #dcdcdc;
  border-radius: 50px;
  padding: 8px 12px;
  text-align: center;
  cursor: pointer;
  font-family: "kumbhRegular";
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
  background-color: white;
  min-width: 100px;
}

.year-pill.active {
  background-color: #005f32;
  color: white;
  border-color: #005f32;
  font-family: "kumbhBold";
}

.year-pill:hover:not(.active) {
  border-color: #005f32;
  color: #005f32;
}

::v-deep .custom-pagination .v-pagination__item {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05) !important;
  font-family: 'KumbhRegular' !important;
  font-size: 15px !important;
  height: 45px !important;
  width: 45px !important;
  min-width: 45px !important;
  margin: 0 8px !important;
  border-radius: 50% !important;
  background-color: white !important;
  color: #333 !important;
  border: none !important;
  transition: all 0.3s ease;
}

::v-deep .custom-pagination .v-pagination__item--active {
  background-color: #005f32 !important;
  color: #ffffff !important;
  box-shadow: 0px 5px 15px rgba(0, 95, 50, 0.35) !important;
}

::v-deep .custom-pagination .v-pagination__navigation {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05) !important;
  height: 45px !important;
  width: 45px !important;
  min-width: 45px !important;
  margin: 0 8px !important;
  border-radius: 50% !important;
  background-color: white !important;
  border: none !important;
}

::v-deep .custom-pagination .v-pagination__navigation .v-icon {
  font-size: 26px !important;
  color: #bbb !important;
}

::v-deep .custom-pagination .v-pagination__more {
  font-family: 'KumbhRegular' !important;
  color: #999 !important;
  margin: 0 8px !important;
}
</style>
